import React from 'react'
import { useAppDispatch, useAppSelector } from 'src/hooks/redux'
import { selectProspects, setPagination, setSelectedSection } from 'src/redux/prospects/prospectsSlice'
import TableHeader from '../common/TableHeader/TableHeader'
import { HeaderProspectsOption } from './constants/ProspectsHeaderTable'
import ProspectsCards from './ProspectsCards/ProspectsCards'
import Pagination from '../common/pagination'
import { loadProspects } from 'src/redux/prospects/prospects.thunks'
import { Prospects404 } from './Prospects404/Prospects404'
import Filters from '../common/Filters/Filters'
import { STATUS_PROSPECTS } from './constants/status'

const ProspectsList = () => {
    const { list, loading, pagination, catalogs: { typification, customer_success }, selectedSection: { closed } } = useAppSelector(selectProspects);

    const dispatch = useAppDispatch()
    const loading_number = 24

    const onChangePageHandler = (page: number) => {
        dispatch(setPagination({
            ...pagination,
            page
        }))

        dispatch(loadProspects({ page }))
    };

    const hasData = list.length > 0

    const filterTypification = () => {
        let newArray = []
        // Solo muestra las opciones correspondientes dependiendo la tab
        if (closed === STATUS_PROSPECTS.CLOSED) {
            newArray = typification.filter(item => item.value !== 2);
        } else {
            newArray = typification.filter(item => item.value === 2);
            newArray = [{ value: 0, label: 'Sin tipificación' }, ...newArray]
        }
        return newArray
    }

    const handleFilter = (value) => {
        dispatch(setSelectedSection(value));
    }

    return (
        <>
            <Filters data={{ typification: filterTypification(), customerSuccess: customer_success }} handleFilter={handleFilter} />
            {
                (loading || hasData) &&
                <TableHeader arrayHeaders={HeaderProspectsOption} />
            }

            {loading ? [...Array(loading_number)].map((_, i) => (
                <ProspectsCards key={`prospect-card-skeleton-${i + 1}`} prospect={null} loading={loading} />
            )) : <>
                {hasData && list.map((prospect) => (
                    <ProspectsCards key={`prospect-card-${prospect.id}`} prospect={prospect} loading={loading} />
                ))}
                {!hasData && <Prospects404 />}
            </>
            }
            <Pagination paginate={pagination} onChangePage={onChangePageHandler} />
        </>
    )
}

export default ProspectsList